import { useTranslation } from 'react-i18next';

export default function PricingTable() {
  const { t } = useTranslation();
  
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl text-[#2B2B2B] mb-4">{t('common:pricing.title')}</h2>
          <p className="text-lg text-gray-600">{t('common:pricing.subtitle')}</p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-2xl overflow-hidden shadow-sm">
            <thead>
              <tr className="bg-[#8B9B7E]">
                <th className="px-6 py-5 text-left text-white font-semibold text-lg">{t('common:pricing.serviceType')}</th>
                <th className="px-6 py-5 text-center text-white font-semibold text-lg">{t('common:pricing.bedroom1')}</th>
                <th className="px-6 py-5 text-center text-white font-semibold text-lg">{t('common:pricing.bedroom2')}</th>
                <th className="px-6 py-5 text-center text-white font-semibold text-lg">{t('common:pricing.bedroom3')}</th>
                <th className="px-6 py-5 text-center text-white font-semibold text-lg">Villa/ 4 bed</th>
              </tr>
            </thead>
            <tbody>
              {/* Cleaning Services */}
              <tr className="border-b border-gray-200 hover:bg-[#F5F1ED] transition-colors">
                <td className="px-6 py-5">
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center justify-center w-10 h-10 bg-[#8B9B7E]/10 rounded-lg">
                      <i className="ri-drop-line text-xl text-[#8B9B7E]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-[#2B2B2B]">{t('common:pricing.cleaningServices')}</div>
                      <div className="text-sm text-gray-500">{t('common:pricing.cleaningDesc')}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€79</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€99</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€119</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€149</div>
                </td>
              </tr>

              {/* Maintenance Services */}
              <tr className="border-b border-gray-200 hover:bg-[#F5F1ED] transition-colors">
                <td className="px-6 py-5">
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center justify-center w-10 h-10 bg-[#8B9B7E]/10 rounded-lg">
                      <i className="ri-tools-line text-xl text-[#8B9B7E]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-[#2B2B2B]">{t('common:pricing.maintenance')}</div>
                      <div className="text-sm text-gray-500">{t('common:pricing.maintenanceDesc')}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€99</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€109</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€149</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€179</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
              </tr>

              {/* Interior Design Services */}
              <tr className="hover:bg-[#F5F1ED] transition-colors">
                <td className="px-6 py-5">
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center justify-center w-10 h-10 bg-[#8B9B7E]/10 rounded-lg">
                      <i className="ri-sofa-line text-xl text-[#8B9B7E]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-[#2B2B2B]">{t('common:pricing.interiorDesign')}</div>
                      <div className="text-sm text-gray-500">{t('common:pricing.interiorDesignDesc')}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€99</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€149</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€199</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
                <td className="px-6 py-5 text-center">
                  <div className="font-bold text-[#2B2B2B] text-lg">€250</div>
                  <div className="text-sm text-gray-500">{t('common:pricing.perMonth')}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600 mb-6">{t('common:pricing.allPricesInclude')}</p>
          <button
            onClick={scrollToBooking}
            className="bg-[#8B9B7E] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#7a8a6d] transition-all inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer"
          >
            <span>{t('common:pricing.getQuote')}</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}